<template>
  <v-app id="inspire">
    <!-- <v-navigation-drawer
      v-model="drawer"
      fixed
      app
      class="grey lighten-4"
      >
      <div class="ma-2">
        <v-card class="mb-2">
          <v-card-text class="pa-1">
            <v-list class="pa-0">
              <v-list-tile avatar>
                <v-list-tile-avatar>
                  <v-btn icon class="hidden-xs-only" to="/">
                    <v-icon>arrow_back</v-icon>
                  </v-btn>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title class="title">Carbon</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-text>
            <div class="mb-2">Start Coordinate: <strong>{{ startCoord }}</strong></div>
            <div class="mb-2">End Coordinate: <strong>{{ endCoord }}</strong></div>
            <div>Total Length: <strong>{{ totalLength }} m</strong></div>
          </v-card-text>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout row wrap align-center>
                <v-flex xs6 sm4>
                  <v-subheader>DNH</v-subheader>
                </v-flex>
                <v-flex xs6 sm8>
                  <v-text-field v-model="dbh" label="dbh" :rules="dbhRules" required placeholder="0000"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap align-center>
                <v-flex xs6 sm4>
                  <v-subheader>Rows</v-subheader>
                </v-flex>
                <v-flex xs6 sm8>
                  <v-select v-model="rowCount" :items="count" label="Select..." @change="selectRow()" :rules="rowsRules" required></v-select>
                </v-flex>
              </v-layout>
              <v-divider class="mb-3"></v-divider>
              <v-layout v-for="(row, index) in rows" :key="index" row wrap align-center>
                <v-flex xs6 sm4 class="py-0">
                  <v-subheader>{{ row.name }}</v-subheader>
                </v-flex>
                <v-flex xs6 sm8 class="py-0">
                  <v-select 
                    v-model="row.specie" 
                    :items="species" 
                    label="Species..." 
                    return-object
                    text-value="value" 
                    item-text="label" 
                    :rules="rowRules" 
                    @change="changeSpecie(row)"
                    required></v-select>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions class="pa-3">
            <v-spacer />
            <v-btn color="green darken-2" round outline dark  @click="calc()">Calculate</v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-navigation-drawer> -->
    <v-content>
      <v-container grid-list-xl>
        <v-layout wrap>
          <v-flex xs12>
            <v-card class="mb-2">
              <v-toolbar flat transparent>
                <v-btn icon class="hidden-xs-only" to="/">
                  <v-icon>arrow_back</v-icon>
                </v-btn>
                <v-toolbar-title>Carbon</v-toolbar-title>
                <v-spacer />
                <v-btn color="green darken-2" round dark @click="dialog = true">Calculate</v-btn>
              </v-toolbar>
            </v-card>
          </v-flex>
          <v-flex xs12>
            <v-card>
              <v-card-text>
                <v-layout wrap>
                  <v-flex xs12 sm6>
                    <div class="mb-2">
                      Start Coordinate: <strong>{{ startCoord }}</strong>
                    </div>
                    <div class="mb-2">
                      End Coordinate: <strong>{{ endCoord }}</strong>
                    </div>
                    <div class="mb-2">
                      Total Length: <strong>{{ totalLength }} m</strong>
                    </div>
                    <div>
                      DBH: <strong>{{ dbh }}</strong>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <div v-for="row in rows" :key="row.id">
                      <div class="mb-2">
                        {{ row.name }}:
                        <strong>{{ row.value }} - {{ row.label }}</strong>
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12>
            <stack-chart
              :items="biomassDatas"
              :categories="categories"
              title="Bio Mass"
            ></stack-chart>
          </v-flex>
          <v-flex xs12>
            <stack-chart
              :items="domDatas"
              :categories="categories"
              title="Dom"
            ></stack-chart>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

    <v-dialog v-model="dialog" max-width="35%">
      <v-card>
        <v-card-title class="headline">Calculate</v-card-title>
        <v-card-text>
          <div class="mb-2">
            Start Coordinate: <strong>{{ startCoord }}</strong>
          </div>
          <div class="mb-2">
            End Coordinate: <strong>{{ endCoord }}</strong>
          </div>
          <div>
            Total Length: <strong>{{ totalLength }} m</strong>
          </div>
        </v-card-text>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-layout row wrap align-center>
                <v-flex xs6 sm3>
                  <v-subheader>Rows</v-subheader>
                </v-flex>
                <v-flex xs6 sm9>
                  <v-select
                    v-model="rowCount"
                    :items="count"
                    label="Select..."
                    @change="selectRow()"
                    :rules="rowsRules"
                    required
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-divider class="mb-3"></v-divider>
              <v-layout
                v-for="(row, index) in rows"
                :key="index"
                row
                wrap
                align-center
              >
                <v-flex xs6 sm3 class="py-0">
                  <v-subheader>{{ row.name }}</v-subheader>
                </v-flex>
                <v-flex xs6 sm6>
                  <v-select
                    v-model="row.specie"
                    :items="species"
                    label="Species..."
                    return-object
                    text-value="value"
                    item-text="label"
                    :rules="rowRules"
                    @change="changeSpecie(row)"
                    required
                  ></v-select>
                </v-flex>
                <v-flex xs6 sm3>
                  <v-text-field
                    v-model="row.dbh"
                    label="DBH"
                    :rules="dbhRules"
                    required
                    placeholder="0000"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="green darken-2" flat round @click="dialog = false"
            >Close</v-btn
          >
          <v-btn color="green darken-2" flat round @click="calc()"
            >Calculate</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="loading" persistent width="300">
      <v-card color="green darken-2" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import axios from "axios";
import generic from "../mixins/generic";
import StackChart from "./stack_chart";

export default {
  name: "Row",
  mixins: [generic],
  data() {
    return {
      dbh: null,
      totalLength: this.$route.params.total,
      startCoord: this.$route.params.start,
      endCoord: this.$route.params.end,
      drawer: null,
      valid: true,
      dbhRules: [v => !!v || "DBH is required"],
      rowRules: [v => !!v || "Row is required"],
      rowsRules: [v => !!v || "Rows is required"],
      count: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      species: [
        { label: "Caragana Spacing", value: "CA" },
        { label: "White Spruce Spacing", value: "WS" },
        { label: "Scots Pine Spacing", value: "SP" },
        { label: "Green Ash", value: "GA" },
        { label: "Hybrid Poplar", value: "HP" },
        { label: "Manitoba Maple", value: "MM" }
      ],
      rowCount: null,
      rows: [],
      hidden: false,
      items: [],
      loading: false,
      dialog: true,
      biomassDatas: [],
      domDatas: [],
      categories: []
    };
  },
  components: {
    StackChart
  },
  methods: {
    selectRow() {
      this.rows = [];

      for (var i = 1; i <= this.rowCount; i++) {
        var obj = {};
        obj.name = "Row " + i;
        obj.dbh = null;
        obj.index = i;
        obj.value = null;
        obj.label = null;
        this.rows.push(obj);
      }
    },
    changeSpecie(item) {
      item.value = item.specie.value;
      item.label = item.specie.label;
    },
    calc() {
      var vm = this;

      if (vm.$refs.form.validate()) {
        vm.items = [];
        let url = `${process.env.API_ROOT}/carbon/past/${vm.startCoord}/${vm.endCoord}/${vm.totalLength}`;
        vm.hidden = true;

        if (vm.rows.length > 0) {
          let body = [];
          vm.loading = true;

          vm.rows.forEach(function(item) {
            var obj = {
              index: item.index,
              dbh: item.dbh,
              value: item.value
            };
            body.push(obj);
          });

          axios
            .post(url, body)
            .then(response => {
              vm.parseArray(response.data.carbonResultSubTOs);
              vm.loading = false;
              vm.dialog = false;
            })
            .catch(err => {
              vm.loading = false;
            });
        }
      }
    },
    parseArray(array) {
      let biomassDatas = [];
      let domDatas = [];
      let categories = [];

      array.forEach(function(child, index) {
        if (child.pCarbArray) {
          let data = `${child.speciesTO.value} ${child.soilZone} ${child.age} ${child.dbh}`;

          child.pCarbArray.forEach(function(array, arrayIndex) {
            array.forEach(function(arr, index) {
              if (arr < 1 && arr > 0) {
                var name = `Soil Zone: ${parseInt(arrayIndex) + 1}<br/>`;

                var label =
                  "Soil Zone: " +
                  child.soilZone +
                  "<br/>" +
                  "Age: " +
                  child.age +
                  "<br/>" +
                  "DBH: " +
                  child.dbh +
                  "<br/>";

                var obj = {};
                obj.name = name;
                obj.label = label;
                obj.data = arr;
                obj.stack = arrayIndex;

                if (index == 1) {
                  biomassDatas.push(obj);
                }

                if (index == 2) {
                  domDatas.push(obj);
                }
              }
            });
          });
          categories.push(data);
        }
      });

      var domNewDatas = _.chain(domDatas)
        .groupBy("stack")
        .map(function(v, i) {
          return {
            name: _.get(_.find(v, "name"), "name"),
            stack: _.get(_.find(v, "label"), "label"),
            data: _.map(v, "data")
          };
        })
        .value();

      var biomassNewDatas = _.chain(biomassDatas)
        .groupBy("stack")
        .map(function(v, i) {
          return {
            name: _.get(_.find(v, "name"), "name"),
            stack: _.get(_.find(v, "label"), "label"),
            data: _.map(v, "data")
          };
        })
        .value();

      this.categories = categories;
      this.biomassDatas = biomassNewDatas;
      this.domDatas = domNewDatas;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/carbon.vue